// Export the Icon component itself
export * from './icon'

export function isValidIconName(name?: unknown): name is IconNameType {
  if (!name || typeof name !== 'string') return false

  return iconList[name as IconNameType] !== undefined
}

export type IconNameType = keyof typeof iconList

const root = ''
const calendar = 'calendar'
const chartLayouts = 'chart-layouts'
const chartTools = 'chart-tools'
const chartTypes = 'chart-types'
const screener = 'screener'

// Export list of icon components
export const iconList = {
  // Main icons
  add: root,
  aiGenerated: root,
  arrowBackward: root,
  arrowDownShort: root,
  arrowForward: root,
  arrowLongRight: root,
  arrowUpShort: root,
  bookOpened: root,
  briefcase: root,
  calendar: root,
  caretDown: root,
  caretLeft: root,
  caretRight: root,
  caretUp: root,
  caretVertical: root,
  chartBar: root,
  chartBubble: root,
  chartCandle: root,
  chartCandleSingle: root,
  chartPie: root,
  chartTable: root,
  chartTreemap: root,
  checkboxTick: root,
  checkmarkOutlined: root,
  chevronDown: root,
  chevronLeft: root,
  chevronRight: root,
  chevronUp: root,
  clearCircle: root,
  close: root,
  crypto: root,
  darkMode: root,
  dashboard: root,
  diamondOutlined: root,
  dollar: root,
  done: root,
  drag: root,
  draw: root,
  empty: root,
  exitFullscreen: root,
  findReplace: root,
  flash: root,
  fullscreen: root,
  gesture: root,
  gift: root,
  grid: root,
  groupSenior: root,
  hamburger: root,
  help: root,
  idea: root,
  ideaLoad: root,
  ideaSave: root,
  import: root,
  info: root,
  interval: root,
  lightMode: root,
  link: root,
  lock: root,
  lockOpened: root,
  menuClose: root,
  minus: root,
  moonFilled: root,
  more: root,
  note: root,
  notifications: root,
  openInNew: root,
  palette: root,
  profile: root,
  publish: root,
  refresh: root,
  remove: root,
  restore: root,
  search: root,
  sectionClose: root,
  sectionOpen: root,
  settings: root,
  settingsBack: root,
  settingsWheel: root,
  share: root,
  signOut: root,
  star: root,
  starOutlined: root,
  swapHorizontal: root,
  switchHorizontal: root,
  switchVertical: root,
  tabKey: root,
  template: root,
  thumbsDown: root,
  thumbsUp: root,
  trashCan: root,
  trendingDown: root,
  trendingUp: root,
  triangle: root,
  triangleOutlineDown: root,
  triangleOutlineUp: root,
  video: root,
  voiceLine: root,
  warning: root,
  warningOutlined: root,
  website: root,
  bellActive: root,
  bellOutlined: root,
  copy: root,

  // Calendar
  impact1: calendar,
  impact2: calendar,
  impact3: calendar,
  impactDark1: calendar,
  impactDark2: calendar,
  impactDark3: calendar,

  // Chart layouts
  layout1h1v: chartLayouts,
  layout1h2v: chartLayouts,
  layout1h3v: chartLayouts,
  layout1l2r: chartLayouts,
  layout1t2b: chartLayouts,
  layout2h1v: chartLayouts,
  layout2h2v: chartLayouts,
  layout3h1v: chartLayouts,
  layout3h2v: chartLayouts,

  // Chart tools
  drawingActionDelete: chartTools,
  drawingSettingAutosaveOff: chartTools,
  drawingSettingAutosaveOn: chartTools,
  drawingSettingAutosaveSaving: chartTools,
  drawingSettingDrawingMode: chartTools,
  drawingSettingDrawingModeActive: chartTools,
  drawingSettingHide: chartTools,
  drawingSettingLock: chartTools,
  drawingSettingPreserveDrawings: chartTools,
  drawingSettingPreserveDrawingsActive: chartTools,
  drawingSettingShow: chartTools,
  drawingSettingUnlock: chartTools,
  toolArrow: chartTools,
  toolAVWAP: chartTools,
  toolBrush: chartTools,
  toolCallout: chartTools,
  toolCurve: chartTools,
  toolElliottWave: chartTools,
  toolEllipse: chartTools,
  toolExpand: chartTools,
  toolFibonacci: chartTools,
  toolLine: chartTools,
  toolMeasure: chartTools,
  toolMidLineH: chartTools,
  toolMidLineV: chartTools,
  toolMouse: chartTools,
  toolPitchfork: chartTools,
  toolPolygon: chartTools,
  toolPosition: chartTools,
  toolRect: chartTools,
  toolRectRotated: chartTools,
  toolText: chartTools,
  toolTriangle: chartTools,
  toolXABCD: chartTools,

  // Chart types
  candleBarBasic: chartTypes,
  candleBarHeikinAshi: chartTypes,
  candleBarHollow: chartTypes,
  lineChartType: chartTypes,
  ohlcChartType: chartTypes,

  // Screener
  above: screener,
  aboveEqual: screener,
  abovePercent: screener,
  below: screener,
  belowEqual: screener,
  belowPercent: screener,
  between: screener,
  crosses: screener,
  crossesDown: screener,
  crossesUp: screener,
  equal: screener,
  outside: screener,
}
